<app-thrive-splash>
  <div fxLayout="row" fxLayoutAlign="center center">
    <app-thrive-card>
      <mat-card-content>
        <div> {{'Sorry_PageTriedToAccessN0Exist' | translate}} </div>
      </mat-card-content>
    </app-thrive-card>
  </div>
</app-thrive-splash>
